import CustomMargin from "../../../components/custom-margin";
import { useState } from 'react';
import AlertComponent from '../../../components/alert-component';

export default function ContactForm() {
    const [value, setValue] = useState({
        name: '',
        gender: '',
        birthdate: '',
        age: '',
        address: '',
        civilStatus: '',
        citizenship: '',
        contactNumber: '',
        email: '',
        purposeOfConsultation: '',
        briefNarrationOfTheCase: '',
    });

    const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const phonePattern = /^(?:\+63|0)9[0-9]{9}$/;
    const [alertMessage, setAlertMessage] = useState('');
    const [isAlert, setAlert] = useState(false);

    const areAllValuesFilled = (obj) => {
        return Object.values(obj).every(value => value.trim() !== '');
    };

    const showAlert = (message) => {
        setAlertMessage(message);
        setAlert(true);
        setTimeout(() => setAlert(false), 2000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!emailPattern.test(value.email)  ) {
            showAlert("Invalid email format. Please use email@domain.com.");
        } else if (!phonePattern.test(value.contactNumber)) {
            showAlert("Enter a valid Philippine mobile number.");
        } else if (!areAllValuesFilled(value)) {
            showAlert("Please fill out all the fields.");
        } else {
            const formData = new FormData(e.target);

            formData.append("access_key", "ab73a0b8-df2d-4209-bfbc-4bdccb6aa090");

            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                e.target.reset();
                showAlert("Your message has been sent. Please wait for a response.")
            } else {
                console.log("Error", data);
            }
        }
    };

    return (
        <CustomMargin className="mx-auto w-[calc(100%-2rem)] max-w-6xl rounded-3xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 via-[#111] to-black p-5 text-zinc-300 shadow-2xl shadow-black/40 sm:p-6 lg:p-10">
            {isAlert && (
                <AlertComponent message={alertMessage} duration={2000} />
            )}
            <form onSubmit={handleSubmit} className="[&_label]:font-medium [&_label]:text-zinc-300 [&_small]:text-zinc-500 [&_input]:rounded-lg [&_input]:border-zinc-700 [&_input]:bg-black/40 [&_input]:p-3 [&_input]:text-zinc-100 [&_input]:outline-none [&_input]:transition [&_input:focus]:border-zinc-400 [&_textarea]:rounded-lg [&_textarea]:border-zinc-700 [&_textarea]:bg-black/40 [&_textarea]:p-3 [&_textarea]:text-zinc-100 [&_textarea]:outline-none [&_textarea:focus]:border-zinc-400">
                <div className="flex flex-col items-stretch justify-center gap-5 lg:flex-row">
                    <div className="w-full lg:w-1/2">
                        <div className="flex flex-col mt-3">
                            <label>Name <small>(First Name, Middle Initial, Last Name, Suffix)</small></label>
                            <input 
                                name="name"
                                type="text" 
                                className="border border-black p-1"
                                value={value.name}
                                onChange={(e) => setValue({...value, name: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Gender <small>(Male, Female, Other)</small></label>
                            <input
                                name="gender"                                
                                type="text" 
                                className="border border-black p-1 "
                                value={value.gender}
                                onChange={(e) => setValue({...value, gender: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Birthdate <small>(DD/MM/YYYY)</small></label>
                            <input
                                name="birthdate"
                                type="text" 
                                className="border border-black p-1"
                                value={value.birthdate}
                                onChange={(e) => setValue({...value, birthdate: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Age</label>
                            <input
                                name="age" 
                                type="number" 
                                className="border border-black p-1"
                                value={value.age}
                                onChange={(e) => setValue({...value, age: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Present Location <small>(Street Address, City, Postal Code, Country)</small></label>
                            <input
                                name="address" 
                                type="text" 
                                className="border border-black p-1"
                                value={value.address}
                                onChange={(e) => setValue({...value, address: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className="w-full lg:w-1/2">
                        <div className="flex flex-col mt-3">
                            <label>Civil Status <small>(Single, Married, Widowed, Separated)</small></label>
                            <input
                                name="civilStatus" 
                                type="text" 
                                className="border border-black p-1"
                                value={value.civilStatus}
                                onChange={(e) => setValue({...value, civilStatus: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Citizenship</label>
                            <input
                                name="citizenship" 
                                type="text" 
                                className="border border-black p-1"
                                value={value.citizenship}
                                onChange={(e) => setValue({...value, citizenship: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Contact Number <small>(Use Philippines contact number. +63 or 09)</small></label>
                            <input
                                name="contactNumber" 
                                type="text" 
                                className="border border-black p-1"
                                value={value.contactNumber}
                                onChange={(e) => setValue({...value, contactNumber: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Email <small>(Use valid email address)</small></label>
                            <input
                                name="email" 
                                type="email" 
                                className="border border-black p-1"
                                value={value.email}
                                onChange={(e) => setValue({...value, email: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col mt-3">
                            <label>Purpose of Consultation</label>
                            <input
                                name="purposeOfConsultation"
                                type="text" 
                                className="border border-black p-1"
                                value={value.purposeOfConsultation}
                                onChange={(e) => setValue({...value, purposeOfConsultation: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col mt-3">
                        <label>Brief Narration of the Case</label>
                        <textarea
                            name="briefNarrationOfTheCase" 
                            type="text"
                            rows={3}
                            className="border border-black p-1"
                            value={value.briefNarrationOfTheCase}
                            onChange={(e) => setValue({...value, briefNarrationOfTheCase: e.target.value})}
                        />
                    </div>
                </div>
                <button type="submit" className="mb-1 mt-7 w-full rounded-xl border border-zinc-600 bg-gradient-to-b from-zinc-800 to-zinc-950 px-14 py-4 text-sm tracking-[0.16em] text-white transition hover:border-zinc-300 lg:w-auto">SUBMIT</button>
            </form>
        </CustomMargin>
    );
}
